/* eslint-disable */
import React, { useState } from "react";
import { HiX } from "react-icons/hi";
import { MdLock } from "react-icons/md";
import Links from "./components/Links";
import routes from "routes.js";
import { useAuth } from "views/auth/AuthContext"; // adjust path if needed
import { useNavigate } from "react-router-dom";
import Modal from "components/ui/Modal";

const Sidebar = ({ open, onClose }) => {
  const { token, signout } = useAuth();
  const nav = useNavigate();

  // 🔐 Logout confirm modal state
  const [confirmLogoutOpen, setConfirmLogoutOpen] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  const visibleRoutes = routes.filter((r) => {
    if (r.hidden) return false;
    if (token) return r.layout !== "/auth";
    return r.layout === "/auth";
  });

  // Actual logout logic
  const handleLogout = async () => {
    try {
      setLoggingOut(true);
      await signout();
      nav("/auth/sign-in", { replace: true });
    } finally {
      setLoggingOut(false);
      setConfirmLogoutOpen(false);
    }
  };

  const openConfirm = () => setConfirmLogoutOpen(true);

  const closeConfirm = () => {
    if (loggingOut) return; // don't allow closing while in progress
    setConfirmLogoutOpen(false);
  };
  return (
    <>
      <div
        className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
          open ? "translate-x-0" : "-translate-x-96"
        }`}
      >
        <span
          className="absolute right-4 top-4 block cursor-pointer xl:hidden"
          onClick={onClose}
        >
          <HiX />
        </span>

        <div className="mx-[80px] mt-[50px] flex items-center">
          <img
            src="/logo/StadoPayroll.png"
            alt="Stado Payroll"
            className="h-14 w-auto dark:hidden md:h-16 lg:h-20"
          />

          <img
            src="/logo/StadoDark.png"
            alt="Stado Payroll Dark"
            className="hidden h-14 w-auto dark:block md:h-16 lg:h-20"
          />
        </div>

        <div className="mb-7 mt-[58px] h-px bg-gray-300 dark:bg-white/30" />

        {/* Nav items */}
        <ul className="mb-auto pt-1">
          <Links routes={visibleRoutes} onClose={onClose} />
        </ul>

        {/* Footer action: if logged in, show Logout */}
        {token ? (
          <button
            onClick={openConfirm}
            className="mx-6 mt-4 flex items-center gap-2 rounded-xl 
           bg-gradient-to-r from-[#ef145d] to-[#e3955e]
           px-4 py-2 text-sm font-extrabold text-white 
           shadow-lg transition-all duration-300 
           hover:scale-105 hover:shadow-xl"
          >
            <MdLock className="h-5 w-5" />
            Logout
          </button>
        ) : null}
      </div>

      {/* 🪟 Logout Confirmation Modal */}
      <Modal
        open={confirmLogoutOpen}
        onClose={loggingOut ? undefined : closeConfirm}
        title="Log out from Stado Payroll?"
        size="sm"
      >
        <div className="space-y-4">
          <p className="text-sm text-gray-600 dark:text-white/80">
            Are you sure you want to{" "}
            <span className="font-medium">log out of your account</span>? Any
            unsaved work may be lost.
          </p>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              disabled={loggingOut}
              onClick={closeConfirm}
              className="rounded-lg border px-4 py-2 text-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-brand-500 disabled:opacity-60 dark:border-white/10 dark:text-white dark:hover:bg-navy-700"
            >
              Cancel
            </button>
            <button
              onClick={handleLogout}
              disabled={loggingOut}
              className="focus:ring-rose-500 rounded-lg bg-gradient-to-r from-[#ef145d] to-[#e3955e] px-5 py-2 text-sm text-white hover:opacity-95 focus:outline-none focus:ring-2 disabled:opacity-60"
            >
              {loggingOut ? "Logging out…" : "Logout"}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Sidebar;
